function debounce(func, time = 100) {
    let timeoutId;
    return function (event) {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(func, time, event);
    };
}

export default debounce;
